<script>
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import axios from 'axios';

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";



import headtable from "../dashboard/headtable";

export default {
  page: {
    title: "Dashboards",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data() {
    return {
      title: "Dashboards",
      items: [
        {
          text: "Dashboards",
          href: "/",
        //   showNavbar: false,
        },
      ],

    rangeDateconfig: {
        mode: "range",
        dateFormat: "Y-m-d",
    },

      ListData:[],

        programListClick:[],

      loadingTable:true,
      loadingTableClick:true,
      selectiondate:'',
      stat:'',
      randome:'',
      randomenew:'',
      password:'',
    }
  },

  methods: {
    getListData(search){
        if(search == 'search'){
            this.ListData=[];
        }
        
        this.loadingTable=true;
        
        
        this.url_api = '';
        if (typeof this.$route.query.date !== 'undefined') {
            this.url_api = 'dashboard?date='+this.$route.query.date;
        }else{
            this.url_api = 'dashboard';
        }

        if(this.selectiondate == ''){ //for server
            this.url_api = process.env.VUE_APP_API_BASEURL+'dashboard';
        }else{
            this.url_api = process.env.VUE_APP_API_BASEURL+'dashboard?date='+this.selectiondate;
        }

        if(process.env.VUE_APP_BASE_URL == '/'){ //locahost
            if(this.selectiondate == ''){
                this.url_api = 'https://sw-uat.renewplus.my:3007/api/dashboard';
            }else{
                this.url_api = 'https://sw-uat.renewplus.my:3007/api/dashboard?date='+this.selectiondate;
            }
            
        }
        
        // axios.get(process.env.VUE_APP_API_BASEURL+this.url_api)
        axios.get(this.url_api)
        .then(response => {
            if (response) {
                // this.loadingTable=false;
                this.ListData = response.data.datatable;

                this.stat = response.data.dashboard;
                console.log(this.ListData);
                console.log('--------');
            } 
            else {
                this.messageBag = ['No record.'];
            }
            this.randomeGenerator(10);
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
        this.loadingTable=false;
    },

    DisplayListDetailProgram(program){
        this.randomeGenerator(10);
        this.loadingTableClick=true;
        this.programListClick =  this.ListData.filter(item => item.program_name === program);
        this.loadingTableClick=false;
        // this.$refs.dataTable.$dt.draw();
        // alert(this.programListClick)
    },

    DisplayListDetaiNumber(program,status,number){
        this.randomeGenerator(10);
        this.loadingTableClick=true;

        if(number == '21'){
            this.programListClick = this.ListData.filter(item => {
                return item.program_name === program && item.age > 21 && item.order_status_name === status;
            });
        }else if(number == 11){
            this.programListClick = this.ListData.filter(item => {
                return item.program_name === program && item.age < 11 && item.order_status_name === status;
            });
        }else {
            this.programListClick = this.ListData.filter(item => {
                return item.program_name === program && item.age >= 11 && item.age <= 20 && item.order_status_name === status;
            });
        }
        this.loadingTableClick=false;
    },

    DisplayListDetaiGrandTotal(program,status){
        this.randomeGenerator(10);
        this.loadingTableClick=true;
        // status
        this.programListClick = this.ListData.filter(item => {
                return item.program_name === program && item.order_status_name === status;
        });
        this.loadingTableClick=false;
    },

    totalProgram(datas){
        return datas.reduce((acc, data) => acc + (data.voucher.voucher_value * data.trade_up.quantity), 0); 
    },

    search(){
        if(this.selectiondate != ''){
            this.randomeGenerator(10);
            // alert('add');
            this.$router.push('/dashboard/85b2073a1a1c01f446f45803a6629204a8ddcf5ba3aa2e495d14b67d269ebe66?date='+this.selectiondate);
            this.getListData('search');
        }
    },

    checkpassword(){
        // carenew2024
        if(this.password_input == 'carenew2024'){
            this.password=true;
        }else{
            alert('Password incorect');
        }
    },

    randomeGenerator(length) {
        this.randome = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        let counter = 0;
        while (counter < length) {
            this.randome += characters.charAt(Math.floor(Math.random() * charactersLength));
            counter += 1;
        }
        this.randomenew = this.randome+'xx';
        return this.randome;
    }

  },

  mounted(){

    this.randomeGenerator();
    
    var elem = document.getElementsByClassName("app-menu navbar-menu");
    while (elem.length > 0) {
        elem[0].remove();
    }

    var dropdown = document.getElementsByClassName("dropdown ms-sm-3 header-item topbar-user");
    while (dropdown.length > 0) {
        dropdown[0].remove();
    }
    
    if (typeof this.$route.query.date !== 'undefined') {
        this.selectiondate = this.$route.query.date;
    }
    this.getListData('new');
  },

  components: {
    Layout,
    PageHeader,
    flatPickr,
    headtable
  },
}
require("@/assets/css/datatable.css");

</script>
<style>
.main-content {
    margin-left: 0px;
}
</style>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="card" v-if='password == false'>
            <div class="card-header border-bottom-dashed">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Please enter password</h5> <br>
                        </div>
                         <div class="col-xl-5 pb-3">
                            <div class="input-group">
                                <input type="text" v-model="password_input" class="form-control" />
                                <button class="btn btn-outline-secondary btn-md" type="button">
                                    <div class="btn-content" @click="checkpassword">Submit</div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-auto">
                        <!-- <div>
                            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="card" v-else>
            <div class="card-header border-bottom-dashed">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Order List</h5>
                        </div>
                    </div>
                    <div class="col-sm-auto">
                        <!-- <div>
                            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="card-body border-bottom-dashed border-bottom">
            <!-- <form @submit="submitForm"> -->
                <div class="row g-3">
                    <!--end col-->
                    <div class="col-xl-8 pb-3">
                        <div class="row g-2">
                            <div class="col-sm-6">
                                <div class="">
                                    <flat-pickr v-model="selectiondate" placeholder="Select Order Date" :config="rangeDateconfig"
                                    class="form-control"></flat-pickr>
                                </div>
                            </div>
                            <!--end col-->
                        </div>
                    </div>

                    
                </div>
                <div class="row g-3">
                    <div class="col-xl-2">
                        <div>
                            <button @click="search()" type="submit" class="btn btn-primary w-100">
                                <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                            </button>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-2">
                        <div>
                            <!-- <button @click='resetForm' class="btn btn-danger w-100">
                                <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                            </button> -->
                        </div>
                    </div>
                </div>
                <!--end row-->
                <!-- </form> -->
            </div>
            <div class="card-body">
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingTable'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="row">
                                    <div class="col-lg-8">
                                        <div class="row">
                                            


                                            <div class="col-lg-6">
                                                <b>Program</b>
                                            </div>
                                            <div class="col-lg-1">
                                                <center>
                                                   <b>&lt;1</b>
                                                </center>
                                            </div>
                                            <div class="col-lg-2">
                                                <center>
                                                    <b>11-20</b>
                                                </center>
                                            </div>
                                            <div class="col-lg-1">
                                                <center>
                                                    <b>>21</b>
                                                </center>
                                            </div>
                                            <div class="col-lg-2">
                                                <center>
                                                    <b>Grand Total</b>
                                                </center>
                                            </div>
                                            <div class="col-lg-12">
                                            <hr>
                                            </div>
                                            <span  v-for="(program, programName) in stat" :key="programName">
                                                <div class="col-lg-6">
                                                    <b><a @click="DisplayListDetailProgram(programName)" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg">{{ programName }}</a></b>
                                                </div>
                                                <div class="col-lg-6">
                                                </div>
                                                <div class="col-lg-12" v-for="(status, statusName) in program" :key="statusName">
                                                    <div class="row">
                                                        <div class="col-lg-6" >
                                                            &nbsp;&nbsp;&nbsp;&nbsp; {{ statusName }}
                                                        </div>
                                                        <div class="col-lg-1" >
                                                            <center><a @click="DisplayListDetaiNumber(programName,statusName,'11')" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" >{{ status.age_ranges.underage }}</a></center>
                                                        </div>
                                                        <div class="col-lg-2" >
                                                            <center><a @click="DisplayListDetaiNumber(programName,statusName,'range')" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" >{{ status.age_ranges.belowtwenty}}</a></center>
                                                        </div>
                                                        <div class="col-lg-1" >
                                                            <center><a @click="DisplayListDetaiNumber(programName,statusName,'21')" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" >{{ status.age_ranges.twentyplus}}</a></center>
                                                        </div>
                                                        <div class="col-lg-2" >
                                                            <center><b><a @click="DisplayListDetaiGrandTotal(programName,statusName)" style="cursor: pointer;" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" >{{ status.age_ranges.grandtotal}}</a></b></center>
                                                        </div>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <hr>
                                <div class="table-responsive">
                                    <headtable :ListData="ListData" :dtKey="randomenew"></headtable>
                                </div>

                                 <!-- modal -->
                                <div class="modal fade bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content">
                                            <span v-if="loadingTableClick">
                                                <div class="spinner-border text-success" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                            </span>
                                            <div class="table-responsive" v-else>
                                                
                                                <headtable :ListData="programListClick" :dtKey="randome"></headtable>
                                            </div>
                                        </div>
                                        <!-- /.modal-content -->
                                    </div>
                                    <!-- /.modal-dialog -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        

        


       
        

    </Layout>
</template>